import { redirectingProfileEnum } from "./global-country-dictionary";

const { getApiUrl } = require("@utils/baseUrl");

export const ViewShipmentMirrorDatasets = {
  "russia imports": {
    apiUrl: getApiUrl("intelSearchRussiaImportShipmentByID"),
    viewShipmentObject: [
      {
        id: 1,
        title: "",
        growValue: 12,
        isHeader: true,
        imgUrl: "",
        data: [
          { label: "Date of Declaration", value: "date_of_declaration", dateFormat: true, monthFormat: false },
          { label: "Date of Arrival", value: "date_of_arrival", dateFormat: true, monthFormat: true },
          { label: "Declaration Number", value: "derived_declaration_number" },
          { label: "Item Number", value: "itemCount" },
          { label: "Item Count", value: "total_item_count", isViewAll: "is_view_all", shipmentRedirect: true, requestId: "derived_declaration_number", requestNum: "total_item_count" },
          { label: "HS Code", value: "derived_hs_code" },
          { label: "Mode of Transportation", value: "derived_mode_of_transportation_english" },
          { label: "Incoterm", value: "derived_incoterm_code_description_combined" },
        ],
      },
      {
        id: 2,
        title: "Shipment Origin Details",
        isConnectedColumn: true,
        isCompactHeader: true,
        growValue: 6,
        isHeader: false,
        imgUrl: "",
        data: [
          { label: "Country of Origin", value: "derived_country_of_origin_english", isCapitalise: true, tooltip: true, tooltipField: "country_of_origin_russian", countryCodeField: "originCountry", countryFlag: false },
          { label: "Country of Export", value: "derived_country_of_export", isCapitalise: false, countryFlag: true, countryCodeField: "derived_country_of_export_code" },
          // { label: 'Place of Receipt', value: 'derived_place_of_receipt_english', tooltip: true, tooltipField: 'place_of_receipt_russian' },
          { label: "Producer Name", value: "derived_producer_name_english" },
          { label: "Producer Name (Russian)", value: "producer_name_russian" },
          { label: "Shipper Standardized Name", type: "redirect", companyIdKey: "derived_shipper_master_company_id", companyKey: "", derivedCompanyKey: "derived_shipper_master_name", tradeDirection: "E" },
          { label: "Shipper Name", value: "derived_shipper_name_english" },
          { label: "Shipper Name (Russian)", value: "shipper_name_russian" },
          { label: "Shipper Jurisdiction Country ", value: "derived_shipper_jurisdiction_country", countryFlag: true, countryCodeField: "derived_shipper_jurisdiction_country_code" },
          { label: "Shipper Type", value: "derived_is_exporter" },
          { label: "Shipper Address", value: "derived_shipper_address_english", isReadMore: true, readMoreLength: 45 },
          { label: "Shipper Address (Russian)", value: "shipper_address_russian", isReadMore: true, readMoreLength: 45 },
        ],
      },
      {
        id: 3,
        title: "Shipment Destination Details",
        growValue: 6,
        isHeader: false,
        isCompactHeader: true,
        imgUrl: "",
        data: [
          { label: "Country of Import", value: "derived_country_of_import", tooltip: true, tooltipField: "country_of_destination_russian", tooltipPrefix: "Country Code: ", countryFlag: true, countryCodeField: "derived_country_of_import_code", isCapitalise: false },
          { label: "Consignee Standardized Name", value: "derived_consignee_master_name", type: "redirect", companyIdKey: "derived_consignee_master_company_id", companyKey: "", derivedCompanyKey: "derived_consignee_master_name", tradeDirection: "I" },
          { label: "Consignee Name", value: "derived_consignee_name_english", isCapitalise: true },
          { label: "Consignee Name (Russian)", value: "consignee_name_russian", isCapitalise: true },
          { label: "Consignee Code", value: "consignee_code" },
          { label: "Consignee Type", value: "derived_is_importer" },
          { label: "Consignee Address", value: "derived_consignee_address_english", isReadMore: true, readMoreLength: 45 },
          { label: "Consignee Address (Russian)", value: "consignee_address_russian", isReadMore: true, readMoreLength: 45 },
          { label: "Consignee Jurisdiction Country ", value: "derived_consignee_jurisdiction_country", countryFlag: true, countryCodeField: "derived_consignee_jurisdiction_country_code" },
          { label: "Consignee City", value: "derived_consignee_city" },
          { label: "Consignee State", value: "derived_consignee_state" },
          { label: "Consignee Pincode", value: "derived_consignee_pin_code" },
          // { label: "Consignee Country", value: "derived_consignee_country" },
        ],
      },
      {
        id: 4,
        title: "Carrier Details",
        growValue: 6,
        isHeader: false,
        imgUrl: "https://res.cloudinary.com/ddfycftwg/image/upload/v1640251816/images/website/api-integration/ship-gray_1_jqiqaq.svg",
        data: [{ label: "Type of Vehicle", value: "derived_type_of_vehicle_english", tooltip: true, tooltipField: "type_of_vehicle_russian" }],
      },
      {
        id: 5,
        title: "Cargo Details",
        growValue: 6,
        isHeader: false,
        hideCargo: "bol",
        imgUrl: "https://res.cloudinary.com/ddfycftwg/image/upload/v1640251778/images/website/api-integration/delivery-box_1_1_niaysj.svg",
        data: [
          { label: "Product Description", value: "derived_product_description_english", isReadMore: true, readMoreLength: 45 },
          { label: "Product Description (Russian)", value: "product_description_russian", isReadMore: true, readMoreLength: 45 },
          { label: "Product Trademark", value: "derived_product_brand_trademark_english", tooltip: true, tooltipField: "product_brand_trademark_russian" },
          { label: "Quantity", value: "quantity", unitField: "derived_quantity_unit_english", dynamicUnit: true, unitField2: "", dynamicUnit2: false, tooltip: true, tooltipField: "quantity", tooltipField2: "quantity_unit_russian" },
          { label: "Gross Weight (kg)", value: "gross_weight_kg", valueSuffix: " kg", isCommaFormat: true, infoText: "Gross weight is the weight of the shipment measured after packaging" },
          { label: "Net Weight (kg)", value: "net_weight_kg", valueSuffix: " kg", isCommaFormat: true, infoText: "Net weight is the weight of the shipment measured after packaging" },
          { label: "Shipment Value Per Unit (USD)", value: "derived_shipment_value_usd_per_unit", valuePrefix: "USD " },
          { label: "Shipment Value (USD)", value: "shipment_value_usd", valuePrefix: "USD " },
          { label: "Per Unit Value", value: "derived_shipment_value_usd_per_quantity_unit", valuePrefix: "USD ", isCommaFormat: true },
          { label: "Invoice Value (USD)", value: "derived_invoice_value_usd", valuePrefix: "USD ", tooltip: true, tooltipField: "invoice_value_rubles", tooltipPrefix: "RUB ", isCommaFormat: true, fixedValueUpto: 2 },
          { label: "Customs Value (USD)", value: "derived_customs_value_usd", valuePrefix: "USD ", tooltip: true, tooltipField: "customs_value_rubles", tooltipPrefix: "RUB ", isCommaFormat: true, fixedValueUpto: 2 },
        ],
      },
      {
        id: 6,
        title: "Bill of Lading Details",
        growValue: 6,
        isHeader: false,
        imgUrl: "https://res.cloudinary.com/ddfycftwg/image/upload/v1640251778/images/website/api-integration/delivery-box_1_1_niaysj.svg",
        data: [
          { label: "Total Shipment Value (USD)", valuePrefix: "USD ", value: "total_shipment_value_usd" },
          { label: "Total Invoice Value (USD)", valuePrefix: "USD ", value: "derived_total_invoice_value_usd", tooltip: true, tooltipField: "total_invoice_value_rubles", tooltipPrefix: "RUB " },
          { label: "Total Customs Value (USD)", valuePrefix: "USD ", value: "derived_total_customs_value_usd", tooltip: true, tooltipField: "total_customs_value_rubles", tooltipPrefix: "RUB " },
          { label: "Total Gross Weight (kg)", value: "derived_total_gross_weight_kg", valueSuffix: " kg" },
          { label: "Total Net Weight (kg)", value: "derived_total_net_weight_kg", valueSuffix: " kg" },
        ],
      },
    ],
    defaultKey: { country_small: "russia", countryCaps: "RUSSIA" },
    apiUrlDownload: getApiUrl("renderToPdfRussiaImports"),
  },
  "russia exports": {
    apiUrl: getApiUrl("intelSearchRussiaExportShipmentByID"),
    viewShipmentObject: [
      {
        id: 1,
        title: "",
        growValue: 12,
        isHeader: true,
        imgUrl: "",
        data: [
          { label: "Date of Declaration", value: "date_of_declaration", dateFormat: true, monthFormat: false },
          { label: "Date of Arrival", value: "date_of_arrival", dateFormat: true, monthFormat: true },
          { label: "Declaration Number", value: "derived_declaration_number" },
          { label: "Item Number", value: "itemCount" },
          { label: "Item Count", value: "total_item_count", isViewAll: "is_view_all", shipmentRedirect: true, requestId: "derived_declaration_number", requestNum: "total_item_count" },
          { label: "HS Code", value: "derived_hs_code" },
          { label: "Mode of Transportation", value: "derived_mode_of_transportation_english" },
          { label: "Incoterm", value: "derived_incoterm_code_description_combined" },
        ],
      },
      {
        id: 2,
        title: "Shipment Origin Details",
        isConnectedColumn: true,
        isCompactHeader: true,
        growValue: 6,
        isHeader: false,
        imgUrl: "",
        data: [
          { label: "Country of Export", value: "derived_country_of_export", isCapitalise: false, tooltip: true, tooltipField: "country_of_origin_russian", countryCodeField: "derived_country_of_export_code", countryFlag: true },
          { label: "Country of Origin", value: "derived_country_of_origin_english" },
          { label: "Producer Name", value: "derived_producer_name_english" },
          { label: "Producer Name (Russian)", value: "producer_name_russian" },
          { label: "Shipper Standardized Name", type: "redirect", companyIdKey: "derived_shipper_master_company_id", companyKey: "", derivedCompanyKey: "derived_shipper_master_name", tradeDirection: "E" },
          { label: "Shipper Name", value: "derived_shipper_name_english" },
          { label: "Shipper Name (Russian)", value: "shipper_name_russian" },
          { label: "Shipper Code", value: "shipper_code" },
          { label: "Shipper Type", value: "derived_is_exporter" },
          { label: "Shipper Address", value: "derived_shipper_address_english", isReadMore: true, readMoreLength: 45 },
          { label: "Shipper Address (Russian)", value: "shipper_address_russian", isReadMore: true, readMoreLength: 45 },
          { label: "Shipper City", value: "derived_shipper_city" },
          { label: "Shipper State", value: "derived_shipper_state" },
          { label: "Shipper Jurisdiction Country ", value: "derived_shipper_jurisdiction_country", countryFlag: true, countryCodeField: "derived_shipper_jurisdiction_country_code" },
          { label: "Shipper Pincode", value: "derived_shipper_pin_code" },
        ],
      },
      {
        id: 3,
        title: "Shipment Destination Details",
        growValue: 6,
        isHeader: false,
        isCompactHeader: true,
        imgUrl: "",
        data: [
          { label: "Country of Import", value: "derived_country_of_import", countryCodeField: "derived_country_of_import_code", countryFlag: true },
          // { label: 'Place of Delivery', value: 'derived_place_of_delivery_english', tooltip: true, tooltipField: 'place_of_delivery_russian' },
          // { label: "Country of Destination", value: "derived_country_of_destination_english" },
          { label: "Consignee Standardized Name", value: "derived_consignee_master_name", type: "redirect", companyIdKey: "derived_consignee_master_company_id", companyKey: "", derivedCompanyKey: "derived_consignee_master_name", tradeDirection: "I" },
          { label: "Consignee Name", value: "derived_consignee_name_english", isCapitalise: true },
          { label: "Consignee Name (Russian)", value: "consignee_name_russian", isCapitalise: true },
          { label: "Consignee Code", value: "consignee_code" },
          { label: "Consignee Type", value: "derived_is_importer" },
          { label: "Consignee Jurisdiction Country ", value: "derived_consignee_jurisdiction_country", countryFlag: true, countryCodeField: "derived_consignee_jurisdiction_country_code" },
          { label: "Consignee Address", value: "derived_consignee_address_english", isReadMore: true, readMoreLength: 45 },
          { label: "Consignee Address (Russian)", value: "consignee_address_russian", isReadMore: true, readMoreLength: 45 },
        ],
      },
      {
        id: 4,
        title: "Carrier Details",
        growValue: 6,
        isHeader: false,
        imgUrl: "https://res.cloudinary.com/ddfycftwg/image/upload/v1640251816/images/website/api-integration/ship-gray_1_jqiqaq.svg",
        data: [{ label: "Type of Vehicle", value: "derived_type_of_vehicle_english", tooltip: true, tooltipField: "type_of_vehicle_russian" }],
      },
      {
        id: 5,
        title: "Cargo Details",
        growValue: 6,
        isHeader: false,
        hideCargo: "bol",
        imgUrl: "https://res.cloudinary.com/ddfycftwg/image/upload/v1640251778/images/website/api-integration/delivery-box_1_1_niaysj.svg",
        data: [
          { label: "Product Description", value: "derived_product_description_english", isReadMore: true, readMoreLength: 45 },
          { label: "Product Description (Russian)", value: "product_description_russian", isReadMore: true, readMoreLength: 45 },
          { label: "Product Trademark", value: "derived_product_brand_trademark_english", tooltip: true, tooltipField: "product_brand_trademark_russian" },
          { label: "Quantity", value: "quantity", unitField: "derived_quantity_unit_english", dynamicUnit: true, unitField2: "", dynamicUnit2: false, tooltip: true, tooltipField: "quantity", tooltipField2: "quantity_unit_russian" },
          { label: "Gross Weight (kg)", value: "gross_weight_kg", valueSuffix: " kg", isCommaFormat: true, infoText: "Gross weight is the weight of the shipment measured after packaging" },
          { label: "Net Weight (kg)", value: "net_weight_kg", valueSuffix: " kg", isCommaFormat: true, infoText: "Net weight is the weight of the shipment measured after packaging" },
          { label: "Shipment Value Per Unit (USD)", value: "derived_shipment_value_usd_per_unit", valuePrefix: "USD " },
          { label: "Shipment Value (USD)", value: "shipment_value_usd", valuePrefix: "USD " },
          { label: "Per Unit Value", value: "derived_shipment_value_usd_per_quantity_unit", valuePrefix: "USD ", isCommaFormat: true },
          { label: "Invoice Value (USD)", value: "derived_invoice_value_usd", valuePrefix: "USD ", tooltip: true, tooltipField: "invoice_value_rubles", tooltipPrefix: "RUB ", isCommaFormat: true, fixedValueUpto: 2 },
          { label: "Customs Value (USD)", value: "derived_customs_value_usd", valuePrefix: "USD ", tooltip: true, tooltipField: "customs_value_rubles", tooltipPrefix: "RUB ", isCommaFormat: true, fixedValueUpto: 2 },
        ],
      },
      {
        id: 6,
        title: "Bill of Lading Details",
        growValue: 6,
        isHeader: false,
        imgUrl: "https://res.cloudinary.com/ddfycftwg/image/upload/v1640251778/images/website/api-integration/delivery-box_1_1_niaysj.svg",
        data: [
          { label: "Total Shipment Value (USD)", valuePrefix: "USD ", value: "total_shipment_value_usd" },
          { label: "Total Invoice Value (USD)", valuePrefix: "USD ", value: "derived_total_invoice_value_usd", tooltip: true, tooltipField: "total_invoice_value_rubles", tooltipPrefix: "RUB " },
          { label: "Total Customs Value (USD)", valuePrefix: "USD ", value: "derived_total_customs_value_usd", tooltip: true, tooltipField: "total_customs_value_rubles", tooltipPrefix: "RUB " },
          { label: "Total Gross Weight (kg)", value: "derived_total_gross_weight_kg", valueSuffix: " kg" },
          { label: "Total Net Weight (kg)", value: "derived_total_net_weight_kg", valueSuffix: " kg" },
        ],
      },
    ],
    defaultKey: { country_small: "russia", countryCaps: "RUSSIA" },
    apiUrlDownload: getApiUrl("renderToPdfRussiaExports"),
  },
  "indonesia imports": {
    apiUrl: getApiUrl("indonesiaImportShipmentByID"),
    viewShipmentObject: [
      {
        id: 1,
        title: "",
        growValue: 12,
        isHeader: true,
        imgUrl: "",
        data: [
          { label: "Date Of Arrival", value: "derived_arrival_date", dateFormat: true, monthFormat: false },
          { label: "Registration Date", value: "derived_import_registration_date", dateFormat: true, monthFormat: false },
          // { label: 'Incoterm', value: 'incoterm', tooltip: true, capitalize:true,},
          // { label: 'HS Code', value: 'derived_hs_code', },
          // { label: 'Product Keywords', value: 'product_description', isReadMore: true, readMoreLength: 50,}, // present in design, not in doc
        ],
      },
      {
        id: 2,
        title: "Shipment Origin Details",
        isConnectedColumn: true,
        isCompactHeader: true,
        growValue: 6,
        isHeader: false,
        imgUrl: "",
        data: [
          { label: "Country Of Origin", value: "derived_country_of_origin", countryFlag: true, countryCodeField: "country_of_origin_code", tooltip: true, tooltipField: "country_of_origin_code", tooltipPrefix: "Country of Origin Code: " },
          { label: "Port of Lading", value: "derived_port_of_lading", type: "redirect", redirectionID: "derived_port_of_lading_master_id", profileType: redirectingProfileEnum.portOfLading.key },
          { label: "Shipper Name", value: "shipper_name" },
          { label: "Shipper Jurisdiction Country ", value: "derived_shipper_jurisdiction_country", countryFlag: true, countryCodeField: "derived_shipper_jurisdiction_country_code" },
          { label: "Shipper Standardized Name", type: "redirect", companyIdKey: "derived_shipper_master_company_id", companyKey: "", derivedCompanyKey: "derived_shipper_master_name" },
          { label: "Country of Export", value: "derived_country_of_export", countryFlag: true, countryCodeField: "derived_country_of_export_code", tooltip: true, tooltipField: "shipper_country_code", tooltipPrefix: "Country of Export Code: " }, //code field will be provided by BE
          { label: "Shipper Address", value: "shipper_address", isReadMore: true, readMoreLength: 45 },
        ],
      },
      {
        id: 3,
        title: "Shipment Destination Details",
        growValue: 6,
        isHeader: false,
        isCompactHeader: true,
        imgUrl: "",
        data: [
          { label: "Country of Import", value: "derived_country_of_import", countryFlag: true, countryCodeField: "derived_country_of_import_code", tooltip: true, tooltipField: "country_of_destination_code", tooltipPrefix: "Country of Destination Code: " },
          { label: "Port of Unlading", value: "derived_port_of_unlading", infoText: "Port where the goods were unloaded from a seagoing vessel.", tooltip: true, tooltipPrefix: "Port Code: ", tooltipField: "port_of_unlading", type: "redirect", redirectionID: "derived_port_of_unlading_master_id", profileType: redirectingProfileEnum.portOfUnlading.key },
          { label: "Consignee Name", value: "consignee_name" },
          { label: "Consignee Standardized Name", type: "redirect", companyIdKey: "derived_consignee_master_company_id", companyKey: "", derivedCompanyKey: "derived_consignee_master_name" },
          { label: "Consignee Tax ID", value: "consignee_tax_identification_number" },
          { label: "Consignee Jurisdiction Country ", value: "derived_consignee_jurisdiction_country", countryFlag: true, countryCodeField: "derived_consignee_jurisdiction_country_code" },
          { label: "Consignee Address", value: "consignee_address", isReadMore: true, readMoreLength: 45 },
        ],
      },
      {
        id: 4,
        title: "Customs Details",
        growValue: 6,
        isHeader: false,
        imgUrl: "https://res.cloudinary.com/ddfycftwg/image/upload/v1640251816/images/website/api-integration/ship-gray_1_jqiqaq.svg",
        data: [
          { label: "Customs Data Code", value: "customs_data_code" },
          { label: "Common Access Reference", value: "car_number" },
        ],
      },
      {
        id: 5,
        title: "Cargo Details",
        growValue: 6,
        isHeader: false,
        imgUrl: "https://res.cloudinary.com/ddfycftwg/image/upload/v1640251778/images/website/api-integration/delivery-box_1_1_niaysj.svg",
        data: [
          { label: "HS Code", value: "derived_hs_code" },
          { label: "Product Description", value: "product_description" },
          { label: "Notice Number", value: "notice_number" },
          { label: "Packages", value: "number_of_packs", dynamicUnit: true, unitField: "number_of_packs_unit" },
          { label: "Quantity", value: "quantity", dynamicUnit: true, unitField: "derived_quantity_unit" },
          { label: "Net Weight ", value: "net_weight_kg", valueSuffix: " Kg" },
          { label: "Gross Weight ", value: "total_weight_kg", valueSuffix: " Kg" },
          { label: "Freight ", value: "total_freight_usd", valuePrefix: "USD " },
          { label: "Insurance ", value: "insurance", valuePrefix: "USD " },
          { label: "CIF Value", value: "cif_value_usd", valuePrefix: "USD ", tooltip: true, tooltipField: "cif_tooltip", tooltipPrefix: "CIF Value: " },
          { label: "Per Unit Value", value: "derived_shipment_value_usd_per_quantity_unit", valuePrefix: "USD ", isCommaFormat: true },
          { label: "VAT", value: "vat", valuePrefix: "USD " },
          { label: "Income Tax ", value: "corporate_income_tax", valuePrefix: "USD " },
          { label: "Sales Tax on Luxury Goods ", value: "tax_incentives_on_luxury_goods", valuePrefix: "USD " },
          { label: "Total CIF Value ", value: "total_cif", dynamicUnit: true, unitField: "cif_value_currency" },
          { label: "Total Net Quantity ", value: "total_net_quantity", valueSuffix: " Kg" },
        ],
      },
      {
        id: 6,
        title: "Carrier Details",
        growValue: 6,
        isHeader: false,
        imgUrl: "https://res.cloudinary.com/ddfycftwg/image/upload/v1640251778/images/website/api-integration/delivery-box_1_1_niaysj.svg",
        data: [
          { label: "Carrier Name", value: "derived_carrier_name" },
          { label: "Vessel Name", value: "derived_vessel_name" },
          { label: "Vessel Country", value: "derived_vessel_country", countryFlag: true, countryCodeField: "vessel_country_code", tooltip: true, tooltipField: "vessel_country_code", tooltipPrefix: "Vessel Country Code: " },
        ],
      },
    ],
    defaultKey: { country_small: "indonesia", countryCaps: "INDONESIA" },
    apiUrlDownload: getApiUrl("renderToPdfIndonesiaImports"),
  },
  "indonesia exports": {
    apiUrl: getApiUrl("indonesiaExportShipmentByID"),
    viewShipmentObject: [
      {
        id: 1,
        title: "",
        growValue: 12,
        isHeader: true,
        imgUrl: "",
        data: [
          { label: "Export Registration Date", value: "derived_export_registration_date", dateFormat: true, monthFormat: false },
          { label: "Departure Date", value: "derived_departure_date", dateFormat: true, monthFormat: false },
          { label: "Incoterm", value: "incoterm", tooltip: true, capitalize: true },
          { label: "HS Code", value: "derived_hs_code" },
        ],
      },
      {
        id: 2,
        title: "Shipment Origin Details",
        isConnectedColumn: true,
        isCompactHeader: true,
        growValue: 6,
        isHeader: false,
        imgUrl: "",
        data: [
          { label: "Country of Export", value: "derived_country_of_export", countryFlag: true, countryCodeField: "derived_country_of_export_code", tooltip: true }, //code field will be provided by BE
          { label: "Port of Lading", value: "derived_port_of_lading", type: "redirect", redirectionID: "derived_port_of_lading_master_id", profileType: redirectingProfileEnum.portOfLading.key },
          { label: "Shipper Name", value: "shipper_name" },
          { label: "Shipper Standardized Name", type: "redirect", companyIdKey: "derived_shipper_master_company_id", companyKey: "", derivedCompanyKey: "derived_shipper_master_name" },
          { label: "Shipper Tax Number", value: "shipper_tax_number" },
          { label: "Shipper Province", value: "derived_shipper_province", tooltip: true, tooltipField: "province_code", tooltipPrefix: "Province Code: " },
          { label: "Shipper Zipcode", value: "derived_shipper_zipcode" },
          { label: "Shipper Jurisdiction Country ", value: "derived_shipper_jurisdiction_country", countryFlag: true, countryCodeField: "derived_shipper_jurisdiction_country_code" },
          { label: "Shipper Address", value: "shipper_address", isReadMore: true, readMoreLength: 45 },
          { label: "Is Exporter", value: "derived_is_exporter" },
        ],
      },
      {
        id: 3,
        title: "Shipment Destination Details",
        growValue: 6,
        isHeader: false,
        isCompactHeader: true,
        imgUrl: "",
        data: [
          { label: "Port of Unlading", value: "derived_port_of_unlading", infoText: "Port where the goods were unloaded from a seagoing vessel.", tooltip: true, tooltipPrefix: "Port Code: ", tooltipField: "port_of_unlading", type: "redirect", redirectionID: "derived_port_of_unlading_master_id", profileType: redirectingProfileEnum.portOfUnlading.key },
          { label: "Consignee Name", value: "consignee_name" },
          { label: "Consignee Standardized Name", type: "redirect", companyIdKey: "derived_consignee_master_company_id", companyKey: "", derivedCompanyKey: "derived_consignee_master_name" },
          { label: "Country of Import", value: "derived_country_of_import", countryFlag: true, countryCodeField: "derived_country_of_import_code", tooltip: true, tooltipField: "consignee_country_code", tooltipPrefix: "Country of Import Code: " },
          { label: "Consignee Jurisdiction Country ", value: "derived_consignee_jurisdiction_country", countryFlag: true, countryCodeField: "derived_consignee_jurisdiction_country_code" },
          { label: "Consignee Address", value: "consignee_address", isReadMore: true, readMoreLength: 45 },
          { label: "Is Importer", value: "derived_is_importer" },
        ],
      },
      {
        id: 4,
        title: "Customs Details",
        growValue: 6,
        isHeader: false,
        imgUrl: "https://res.cloudinary.com/ddfycftwg/image/upload/v1640251816/images/website/api-integration/ship-gray_1_jqiqaq.svg",
        data: [
          { label: "Customs Data Code", value: "customs_data_code" },
          { label: "Common Access Reference", value: "car_number" },
        ],
      },
      {
        id: 5,
        title: "Cargo Details",
        growValue: 6,
        isHeader: false,
        imgUrl: "https://res.cloudinary.com/ddfycftwg/image/upload/v1640251778/images/website/api-integration/delivery-box_1_1_niaysj.svg",
        data: [
          { label: "HS Code", value: "derived_hs_code" },
          { label: "Product Description", value: "product_description" },
          { label: "Container Quantity", value: "container_quantity" },
          { label: "Freight", value: "freight_local_currency", valueSuffix: " RP" },
          { label: "Quantity", value: "quantity", dynamicUnit: true, unitField: "derived_quantity_unit" },
          { label: "Net Weight", value: "net_weight_kg", valueSuffix: " Kg" },
          { label: "FOB Value", value: "fob_value_usd", valuePrefix: "USD ", tooltip: true, tooltipField: "fob_currency_unit", tooltipPrefix: "Fob Value Local Currency: " },
          { label: "Per Unit Value", value: "derived_shipment_value_usd_per_quantity_unit", valuePrefix: "USD ", isCommaFormat: true },
          { label: "Insurance ", value: "insurance_usd", valuePrefix: "USD " },
        ],
      },
      {
        id: 6,
        title: "Carrier Details",
        growValue: 6,
        isHeader: false,
        imgUrl: "https://res.cloudinary.com/ddfycftwg/image/upload/v1640251778/images/website/api-integration/delivery-box_1_1_niaysj.svg",
        data: [
          { label: "Carrier Name", value: "derived_carrier_name" },
          { label: "Vessel Name", value: "derived_vessel_name" },
          { label: "Vessel Country", value: "derived_vessel_country", countryFlag: true, countryCodeField: "vessel_country_code", tooltip: true, tooltipField: "vessel_country_code", tooltipPrefix: "Vessel Country Code: " },
          { label: "Voyage Number", value: "voyage_number" },
        ],
      },
    ],
    defaultKey: { country_small: "indonesia", countryCaps: "INDONESIA" },
    apiUrlDownload: getApiUrl("renderToPdfIndonesiaExports"),
  },
  "brazil imports": {
    apiUrl: getApiUrl("getBrazilImportShipmentByID"),
    viewShipmentObject: [
      {
        id: 1,
        title: "",
        growValue: 12,
        isHeader: true,
        imgUrl: "",
        data: [
          { label: "Date of Departure", value: "shipment_departure_date", dateFormat: true, monthFormat: false, preValidate: true },
          { label: "Date of Arrival", value: "shipment_date", dateFormat: true, monthFormat: false },
          { label: "Bill of Lading Number", value: "bill_of_lading_str", preValidate: true },
          { label: "Mode Of Transportation", value: "derived_mode_of_transportation" },
          { label: "HS Code", value: "derived_hs_codes" },
          { label: "Product Keywords", value: "derived_product_description", isReadMore: true, readMoreLength: 40 },
        ],
      },
      {
        id: 2,
        title: "Shipment Origin Details",
        isConnectedColumn: true,
        isCompactHeader: true,
        growValue: 6,
        isHeader: false,
        imgUrl: "",
        data: [
          { label: "Place of Receipt", value: "derived_city_of_origin", tooltip: true, tooltipField: "city_of_origin_code", tooltipPrefix: "Place Of Receipt Code: ", preValidate: true },
          { label: "Place of Receipt Country", value: "derived_country_of_origin", countryFlag: true, countryCodeField: "derived_country_of_origin_code", preValidate: true },
          { label: "Place of Receipt Trade Lane", value: "origin_trade_lane", preValidate: true },
          { label: "Port Of Origin", value: "port_of_origin", preValidate: true },
          { label: "Port Of Origin Country", value: "port_of_origin_country", countryFlag: true, countryCodeField: "port_of_origin_country_code", preValidate: true },
          { label: "Port Of Origin Trade Lane", value: "port_of_origin_trade_lane", preValidate: true },
          { label: "Port Of Maritime Origin", value: "port_of_maritime_origin", tooltip: true, tooltipField: "port_of_maritime_origin_code", tooltipPrefix: "Port Of Maritime Origin Code: ", preValidate: true },
          { label: "Port Of Maritime Origin Country", value: "derived_port_of_maritime_origin_country", countryFlag: true, countryCodeField: "derived_port_of_maritime_origin_country_code", preValidate: true },
          { label: "Port Of Maritime Origin Trade Lane", value: "port_of_maritime_origin_tradelane" },
          { label: "Port Of Lading", value: "derived_port_of_lading", type: "redirect", redirectionID: "derived_port_of_lading_master_id", profileType: redirectingProfileEnum.portOfLading.key },
          { label: "Port Of Lading Country", value: "derived_port_of_lading_country", countryFlag: true, countryCodeField: "derived_port_of_lading_country_code", tooltip: true, tooltipField: "port_of_lading_country_code", tooltipPrefix: "Port Of Lading Country Code: " },
          { label: "Port Of Lading Trade Lane", value: "port_of_lading_trade_lane", preValidate: true },
          { label: "Shipper Standardized Name", value: "derived_shipper_master_name", type: "redirect", companyIdKey: "derived_shipper_master_company_id", companyKey: "", derivedCompanyKey: "derived_shipper_master_name" },
          { label: "Shipper Name", value: "shipper_name" },
          { label: "Shipper Code", value: "shipper_identification_code", preValidate: true },
          { label: "Shipper Type", value: "derived_is_exporter" },
          { label: "Shipper Address", value: "shipper_address", isReadMore: true, readMoreLength: 45 },
          { label: "Country of Export", value: "derived_shipper_country", countryFlag: true, countryCodeField: "derived_shipper_country_code" },
          {
            label: "Shipper Jurisdiction Country",
            value: "derived_shipper_jurisdiction_country",
            countryFlag: true,
            countryCodeField: "derived_shipper_jurisdiction_country_code",
          },
        ],
      },
      {
        id: 3,
        title: "Shipment Destination Details",
        growValue: 6,
        isHeader: false,
        isCompactHeader: true,
        imgUrl: "",
        data: [
          { label: "Port of Unlading", value: "derived_port_of_unlading", tooltip: true, tooltipField: "port_of_unlading_code", tooltipPrefix: "Port Of Unlading Code: ", type: "redirect", redirectionID: "derived_port_of_unlading_master_id", profileType: redirectingProfileEnum.portOfUnlading.key },
          { label: "Port Of Unlading State", value: "port_of_unlading_state", preValidate: true },
          { label: "Port of Unlading Country", value: "port_of_unlading_country", countryFlag: true, countryCodeField: "port_of_unlading_country_code", preValidate: true },
          { label: "Port of Unlading Trade Lane", value: "port_of_unlading_trade_lane", preValidate: true },
          { label: "Port Of Maritime Destination", value: "port_of_maritime_destination", tooltip: true, tooltipField: "port_of_maritime_destination_code", tooltipPrefix: "Port Of Maritime Destination Code: ", preValidate: true },
          { label: "Port Of Maritime Destination Country", value: "port_of_maritime_destination_country", countryFlag: true, countryCodeField: "port_of_maritime_destination_country_code", preValidate: true },
          { label: "Port Of Maritime Destination Trade Lane", value: "port_of_maritime_destination_tradelane", preValidate: true },
          { label: "Place Of Delivery", value: "city_of_destination", tooltip: true, tooltipField: "city_of_destination_code", tooltipPrefix: "Place Of Delivery Code: ", preValidate: true },
          { label: "Place Of Delivery Country", value: "country_of_destination_country", countryFlag: true, countryCodeField: "country_of_destination_country_code", preValidate: true },
          { label: "Place Of Delivery Trade Lane", value: "destination_trade_lane", preValidate: true },
          { label: "Consignee Standardized Name", type: "redirect", companyIdKey: "derived_consignee_master_company_id", companyKey: "", derivedCompanyKey: "derived_consignee_master_name" },
          { label: "Consignee Name", value: "consignee_name" },
          { label: "Consignee Code", value: "consignee_identification_code", preValidate: true },
          { label: "Consignee Type", value: "derived_is_importer" },
          { label: "Consignee Address", value: "derived_consignee_address", isReadMore: true, readMoreLength: 45 },
          { label: "Consignee City", value: "derived_consignee_city" },
          { label: "Consignee State", value: "derived_consignee_state" },
          { label: "Consignee Zip Code", value: "derived_consignee_zipcode" },
          { label: "Country of Import", value: "derived_consignee_country", countryFlag: true, countryCodeField: "derived_consignee_country_code" },
          { label: "Notify Party Name", value: "notify_party_name", preValidate: true },
          { label: "Notify Party Code", value: "notify_party_code", preValidate: true },
          { label: "Notify Party Type", value: "derived_notify_party_is_importer", preValidate: true },
          { label: "Notify Party Address", value: "notify_party_address", isReadMore: true, readMoreLength: 45 },
          {
            label: "Consignee Jurisdiction Country",
            value: "derived_consignee_jurisdiction_country",
            countryFlag: true,
            countryCodeField: "derived_consignee_jurisdiction_country_code",
          },
        ],
      },
      {
        id: 4,
        title: "Carrier Details",
        growValue: 6,
        isHeader: false,
        imgUrl: "https://res.cloudinary.com/ddfycftwg/image/upload/v1640251816/images/website/api-integration/ship-gray_1_jqiqaq.svg",
        data: [
          { label: "VOCC", value: "derived_vocc_master_name", infoText: "Vessel Operating Common Carrier", tooltip: true, tooltipPrefix: "VOCC Code: ", tooltipField: "derived_vocc_code", hideField: true, type: "redirect", redirectionID: "derived_vocc_name_id_combined", profileType: redirectingProfileEnum.vocc.key },
          { label: "NVOCC", value: "derived_nvocc_master_name", infoText: "Non Vessel Operating Common Carrier", tooltip: true, tooltipPrefix: "NVOCC Code: ", tooltipField: "derived_nvocc_code", hideField: true, type: "redirect", redirectionID: "derived_nvocc_name_id_combined", profileType: redirectingProfileEnum.nvocc.key },
          { label: "Freight Forwarder", value: "derived_freight_forwarder_master_name", preValidate: true, type: "redirect", redirectionID: "derived_freight_forwarder_name_id_combined", profileType: redirectingProfileEnum.freightForwarder.key },
          { label: "Forwarder Code", value: "forwarder_code", preValidate: true },
          { label: "Forwarder Type", value: "forwarder_type", preValidate: true },
          { label: "Forwarder Address", value: "forwarder_address", preValidate: true, isReadMore: true, readMoreLength: 45 },
          { label: "Vessel Name", value: "vessel_name", preValidate: true },
          { label: "Carrier Name", value: "scac_name", preValidate: true },
        ],
      },
      {
        id: 5,
        title: "Cargo Details",
        growValue: 6,
        isHeader: false,
        imgUrl: "https://res.cloudinary.com/ddfycftwg/image/upload/v1640251778/images/website/api-integration/delivery-box_1_1_niaysj.svg",
        data: [
          { label: "Product Description", value: "derived_product_description" },
          { label: "Quantity", value: "derived_quantity", unitField: "derived_quantity_unit", dynamicUnit: true, isCommaFormat: true },
          { label: "TEUs", value: "teus", isCommaFormat: true },
          { label: "Weight (kg)", value: "gross_weight_kg", valueSuffix: " kg", isCommaFormat: true },
          { label: "Shipment Value", value: "shipment_value", valuePrefix: "USD ", isCommaFormat: true },
          { label: "Per Unit Value", value: "derived_shipment_value_usd_per_quantity_unit", valuePrefix: "USD ", isCommaFormat: true },
        ],
      },
      {
        id: 6,
        title: "Container Details",
        growValue: 6,
        isHeader: false,
        imgUrl: "https://res.cloudinary.com/ddfycftwg/image/upload/v1640251778/images/website/api-integration/delivery-box_1_1_niaysj.svg",
        data: [
          { label: "Is Containerised", value: "is_containerized" },
          { label: "Container Description", value: "derived_container_description" },
          { label: "Container Type", value: "derived_container_type_description", preValidate: true },
        ],
      },
    ],
    defaultKey: { country_small: "brazil", countryCaps: "BRAZIL" },
    apiUrlDownload: getApiUrl("renderToPdfBrazilImports"),
  },
  "brazil exports": {
    apiUrl: getApiUrl("getBrazilExportShipmentByID"),
    viewShipmentObject: [
      {
        id: 1,
        title: "",
        growValue: 12,
        isHeader: true,
        imgUrl: "",
        data: [
          { label: "Date of Departure", value: "shipment_date", dateFormat: true, monthFormat: false },
          { label: "Bill of Lading Number", value: "bill_of_lading_str", preValidate: true },
          { label: "Mode Of Transportation", value: "mode_of_transportation" },
          { label: "HS Code", value: "derived_hs_codes" },
          { label: "Product Keywords", value: "derived_product_description", isReadMore: true, readMoreLength: 40 },
        ],
      },
      {
        id: 2,
        title: "Shipment Origin Details",
        isConnectedColumn: true,
        isCompactHeader: true,
        growValue: 6,
        isHeader: false,
        imgUrl: "",
        data: [
          { label: "Place Of Receipt", value: "port_of_origin", tooltip: true, tooltipField: "port_of_origin_code", tooltipPrefix: "Place Of Receipt Code: ", preValidate: true },
          { label: "Place Of Receipt Country", value: "port_of_origin_country", countryFlag: true, countryCodeField: "port_of_origin_country_code", preValidate: true },
          { label: "Place Of Receipt Trade Lane", value: "port_of_origin_trade_lane", preValidate: true },
          { label: "Port Of Maritime Origin", value: "port_of_maritime_origin", preValidate: true },
          { label: "Port Of Maritime Origin Country", value: "port_of_maritime_origin_country", countryFlag: true, countryCodeField: "port_of_maritime_origin_country_code", preValidate: true },
          { label: "Port Of Maritime Origin Trade Lane", value: "port_of_maritime_origin_trade_lane", preValidate: true },
          { label: "Port of Lading", value: "derived_port_of_lading", tooltip: true, tooltipField: "port_of_lading_code", tooltipPrefix: "Port Of Lading Code: ", type: "redirect", redirectionID: "derived_port_of_lading_master_id", profileType: redirectingProfileEnum.portOfLading.key },
          { label: "Port of Lading Country", value: "port_of_lading_country", countryFlag: true, countryCodeField: "port_of_lading_country_code" },
          { label: "Port of Lading Trade Lane", value: "port_of_lading_trade_lane", preValidate: true },
          { label: "Shipper Standardized Name", type: "redirect", companyIdKey: "derived_shipper_master_company_id", companyKey: "", derivedCompanyKey: "derived_shipper_master_name" },
          { label: "Shipper Name", value: "shipper_name" },
          { label: "Shipper Code", value: "shipper_identification_code", preValidate: true },
          { label: "Shipper Type", value: "derived_is_exporter" },
          { label: "Shipper Address", value: "shipper_address", isReadMore: true, readMoreLength: 45 },
          { label: "Shipper City", value: "derived_shipper_city" },
          { label: "Shipper State", value: "derived_shipper_state" },
          { label: "Shipper Zip Code", value: "derived_shipper_zipcode" },
          { label: "Country of Export", value: "derived_shipper_country", countryFlag: true, countryCodeField: "derived_shipper_country_code" },
          {
            label: "Shipper Jurisdiction Country",
            value: "derived_shipper_jurisdiction_country",
            countryFlag: true,
            countryCodeField: "derived_shipper_jurisdiction_country_code",
          },
        ],
      },
      {
        id: 3,
        title: "Shipment Destination Details",
        growValue: 6,
        isHeader: false,
        isCompactHeader: true,
        imgUrl: "",
        data: [
          { label: "Port Of Unlading", value: "derived_port_of_unlading", tooltip: true, tooltipField: "port_of_unlading_code", tooltipPrefix: "Port Of Unlading Code: ", type: "redirect", redirectionID: "derived_port_of_unlading_master_id", profileType: redirectingProfileEnum.portOfUnlading.key },
          { label: "Port of Unlading Country", value: "port_of_unlading_country", countryFlag: true, countryCodeField: "port_of_unlading_country_code" },
          { label: "Port of Unlading Trade Lane", value: "port_of_unlading_trade_lane", preValidate: true },
          { label: "Port Of Maritime Destination", value: "port_of_maritime_destination", preValidate: true },
          { label: "Port Of Maritime Destination Country", value: "derived_port_of_maritime_destination_country", countryFlag: true, countryCodeField: "derived_port_of_maritime_destination_country_code", preValidate: true },
          { label: "Port Of Maritime Destination Trade Lane", value: "port_of_maritime_destination_trade_lane", preValidate: true },
          { label: "Place Of Delivery", value: "port_of_destination", tooltip: true, tooltipField: "port_of_destination_code", tooltipPrefix: "Place Of Delivery Code: ", preValidate: true },
          { label: "Place Of Delivery Country", value: "derived_port_of_destination_country", countryFlag: true, countryCodeField: "derived_port_of_destination_country_code", preValidate: true },
          { label: "Place Of Delivery Trade Lane", value: "port_of_destination_trade_lane", preValidate: true },
          { label: "Consignee Standardized Name", type: "redirect", companyIdKey: "derived_consignee_master_company_id", companyKey: "", derivedCompanyKey: "derived_consignee_master_name" },
          { label: "Consignee Name", value: "consignee_name" },
          { label: "Consignee Code", value: "consignee_identification_code", preValidate: true },
          { label: "Consignee Type", value: "derived_is_importer" },
          { label: "Consignee Address", value: "consignee_address", isReadMore: true, readMoreLength: 45 },
          { label: "Consignee Zip Code", value: "derived_consignee_zipcode" },
          { label: "Country of Import", value: "derived_consignee_country", countryFlag: true, countryCodeField: "derived_consignee_country_code" },
          { label: "Notify Party Name", value: "notify_party_name", preValidate: true },
          { label: "Notify Party Code", value: "notify_party_code", preValidate: true },
          { label: "Notify Party Type", value: "derived_notify_party_is_exporter", preValidate: true },
          { label: "Notify Party Address", value: "notify_party_address", preValidate: true, isReadMore: true, readMoreLength: 45 },
          {
            label: "Consignee Jurisdiction Country",
            value: "derived_consignee_jurisdiction_country",
            countryFlag: true,
            countryCodeField: "derived_consignee_jurisdiction_country_code",
          },
        ],
      },
      {
        id: 4,
        title: "Carrier Details",
        growValue: 6,
        isHeader: false,
        imgUrl: "https://res.cloudinary.com/ddfycftwg/image/upload/v1640251816/images/website/api-integration/ship-gray_1_jqiqaq.svg",
        data: [
          { label: "VOCC", value: "derived_vocc_master_name", infoText: "Vessel Operating Common Carrier", tooltip: true, tooltipPrefix: "VOCC Code: ", tooltipField: "derived_vocc_code", hideField: true, type: "redirect", redirectionID: "derived_vocc_name_id_combined", profileType: redirectingProfileEnum.vocc.key },
          { label: "NVOCC", value: "derived_nvocc_master_name", infoText: "Non Vessel Operating Common Carrier", tooltip: true, tooltipPrefix: "NVOCC Code: ", tooltipField: "derived_nvocc_code", hideField: true, type: "redirect", redirectionID: "derived_nvocc_name_id_combined", profileType: redirectingProfileEnum.nvocc.key },
          { label: "Freight Forwarder", value: "forwarder_name", preValidate: true, type: "redirect", redirectionID: "derived_freight_forwarder_name_id_combined", profileType: redirectingProfileEnum.freightForwarder.key },
          { label: "Forwarder Code", value: "forwarder_code", preValidate: true },
          { label: "Forwarder Type", value: "forwarder_type", preValidate: true },
          { label: "Forwarder Address", value: "forwarder_address", preValidate: true, isReadMore: true, readMoreLength: 45 },
          { label: "Vessel Name", value: "vessel_name", preValidate: true },
          { label: "Carrier Name", value: "carrier_name", tooltip: true, tooltipField: "scac_code", tooltipPrefix: "Carrier SCAC Code: ", preValidate: true },
        ],
      },
      {
        id: 5,
        title: "Cargo Details",
        growValue: 6,
        isHeader: false,
        imgUrl: "https://res.cloudinary.com/ddfycftwg/image/upload/v1640251778/images/website/api-integration/delivery-box_1_1_niaysj.svg",
        data: [
          { label: "Product Description", value: "derived_product_description", isCapitalise: true },
          { label: "Quantity", value: "derived_quantity", unitField: "derived_quantity_unit", dynamicUnit: true, isCommaFormat: true },
          { label: "TEUs", value: "teus", isCommaFormat: true },
          { label: "Weight", value: "gross_weight_kg", valueSuffix: " kg", isCommaFormat: true },
          { label: "Shipment Value", value: "shipment_value", valuePrefix: "USD ", isCommaFormat: true },
          { label: "Per Unit Value", value: "derived_shipment_value_usd_per_quantity_unit", valuePrefix: "USD ", isCommaFormat: true },
        ],
      },
      {
        id: 6,
        title: "Container Details",
        growValue: 6,
        isHeader: false,
        imgUrl: "https://res.cloudinary.com/ddfycftwg/image/upload/v1640251778/images/website/api-integration/delivery-box_1_1_niaysj.svg",
        data: [
          { label: "Is Containerised", value: "is_containerized" },
          { label: "Container Description", value: "derived_container_description" },
          { label: "Container Type", value: "derived_container_type_description", preValidate: true },
        ],
      },
    ],
    defaultKey: { country_small: "brazil", countryCaps: "BRAZIL" },
    apiUrlDownload: getApiUrl("renderToPdfBrazilExports"),
  },
  "turkey imports": {
    apiUrl: getApiUrl("intelSearchTurkeyImportShipmentByID"),
    viewShipmentObject: [
      {
        id: 1,
        title: "",
        growValue: 12,
        isHeader: true,
        imgUrl: "",
        data: [
          { label: "Date of Declaration", value: "date_of_declaration", dateFormat: true, monthFormat: false },
          { label: "Date of Arrival", value: "date_of_arrival", dateFormat: true, monthFormat: true },
          { label: "Declaration Number", value: "derived_declaration_number" },
          { label: "Item Number", value: "itemCount" },
          { label: "Item Count", value: "total_item_count", isViewAll: "is_view_all", shipmentRedirect: true, requestId: "derived_declaration_number", requestNum: "total_item_count" },
          { label: "HS Code", value: "hs_code" },
          { label: "Mode of Transportation", value: "derived_mode_of_transportation_english" },
          { label: "Incoterm", value: "derived_incoterm_code_description_combined" },
        ],
      },
      {
        id: 2,
        title: "Shipment Origin Details",
        isConnectedColumn: true,
        isCompactHeader: true,
        growValue: 6,
        isHeader: false,
        imgUrl: "",
        data: [
          { label: "Country of Origin", value: "derived_country_of_origin_english", isCapitalise: true, tooltip: true, tooltipField: "country_of_origin_russian", countryCodeField: "originCountry", countryFlag: false },
          { label: "Country of Export", value: "derived_country_of_export", isCapitalise: false, countryFlag: true, countryCodeField: "derived_country_of_export_code" },
          // { label: 'Place of Receipt', value: 'derived_place_of_receipt_english', tooltip: true, tooltipField: 'place_of_receipt_russian' },
          { label: "Producer Name", value: "derived_producer_name_english" },
          { label: "Producer Name (Russian)", value: "producer_name_russian" },
          { label: "Shipper Standardized Name", type: "redirect", companyIdKey: "derived_shipper_master_company_id", companyKey: "", derivedCompanyKey: "derived_shipper_master_name", tradeDirection: "E" },
          { label: "Shipper Name", value: "derived_shipper_name_english" },
          { label: "Shipper Name (Russian)", value: "shipper_name_russian" },
          { label: "Shipper Type", value: "derived_is_exporter" },
          { label: "Shipper Jurisdiction Country ", value: "derived_shipper_jurisdiction_country", countryFlag: true, countryCodeField: "derived_shipper_jurisdiction_country_code" },
          { label: "Shipper Address", value: "derived_shipper_address_english", isReadMore: true, readMoreLength: 45 },
          { label: "Shipper Address (Russian)", value: "shipper_address_russian", isReadMore: true, readMoreLength: 45 },
        ],
      },
      {
        id: 3,
        title: "Shipment Destination Details",
        growValue: 6,
        isHeader: false,
        isCompactHeader: true,
        imgUrl: "",
        data: [
          { label: "Country of Import", value: "derived_country_of_import", tooltip: true, tooltipField: "country_of_destination_russian", tooltipPrefix: "Country Code: ", countryFlag: true, countryCodeField: "derived_country_of_import_code", isCapitalise: false },
          { label: "Consignee Standardized Name", value: "derived_consignee_master_name", type: "redirect", companyIdKey: "derived_consignee_master_company_id", companyKey: "", derivedCompanyKey: "derived_consignee_master_name", tradeDirection: "I" },
          { label: "Consignee Name", value: "derived_consignee_name_english", isCapitalise: true },
          { label: "Consignee Name (Russian)", value: "consignee_name_russian", isCapitalise: true },
          { label: "Consignee Code", value: "consignee_code" },
          { label: "Consignee Type", value: "derived_is_importer" },
          { label: "Consignee Address", value: "derived_consignee_address_english", isReadMore: true, readMoreLength: 45 },
          { label: "Consignee Address (Russian)", value: "consignee_address_russian", isReadMore: true, readMoreLength: 45 },
          { label: "Consignee City", value: "derived_consignee_city" },
          { label: "Consignee State", value: "derived_consignee_state" },
          { label: "Consignee Jurisdiction Country ", value: "derived_consignee_jurisdiction_country", countryFlag: true, countryCodeField: "derived_consignee_jurisdiction_country_code" },
          { label: "Consignee Pincode", value: "derived_consignee_pin_code" },
          // { label: "Consignee Country", value: "derived_consignee_country" },
        ],
      },
      {
        id: 4,
        title: "Carrier Details",
        growValue: 6,
        isHeader: false,
        imgUrl: "https://res.cloudinary.com/ddfycftwg/image/upload/v1640251816/images/website/api-integration/ship-gray_1_jqiqaq.svg",
        data: [{ label: "Type of Vehicle", value: "derived_type_of_vehicle_english", tooltip: true, tooltipField: "type_of_vehicle_russian" }],
      },
      {
        id: 5,
        title: "Cargo Details",
        growValue: 6,
        isHeader: false,
        hideCargo: "bol",
        imgUrl: "https://res.cloudinary.com/ddfycftwg/image/upload/v1640251778/images/website/api-integration/delivery-box_1_1_niaysj.svg",
        data: [
          { label: "Product Description", value: "derived_product_description_english", isReadMore: true, readMoreLength: 45 },
          { label: "Product Description (Russian)", value: "product_description_russian", isReadMore: true, readMoreLength: 45 },
          { label: "Product Trademark", value: "derived_product_brand_trademark_english", tooltip: true, tooltipField: "product_brand_trademark_russian" },
          { label: "Quantity", value: "quantity", unitField: "derived_quantity_unit_english", dynamicUnit: true, unitField2: "", dynamicUnit2: false, tooltip: true, tooltipField: "quantity", tooltipField2: "quantity_unit_russian" },
          { label: "Gross Weight (kg)", value: "gross_weight_kg", valueSuffix: " kg", isCommaFormat: true, infoText: "Gross weight is the weight of the shipment measured after packaging" },
          { label: "Net Weight (kg)", value: "net_weight_kg", valueSuffix: " kg", isCommaFormat: true, infoText: "Net weight is the weight of the shipment measured after packaging" },
          { label: "Shipment Value Per Unit (USD)", value: "derived_shipment_value_usd_per_unit", valuePrefix: "USD " },
          { label: "Shipment Value (USD)", value: "shipment_value_usd", valuePrefix: "USD " },
          { label: "Per Unit Value", value: "derived_shipment_value_usd_per_quantity_unit", valuePrefix: "USD ", isCommaFormat: true },
          { label: "Invoice Value (USD)", value: "derived_invoice_value_usd", valuePrefix: "USD ", tooltip: true, tooltipField: "invoice_value_rubles", tooltipPrefix: "RUB ", isCommaFormat: true, fixedValueUpto: 2 },
          { label: "Customs Value (USD)", value: "derived_customs_value_usd", valuePrefix: "USD ", tooltip: true, tooltipField: "customs_value_rubles", tooltipPrefix: "RUB ", isCommaFormat: true, fixedValueUpto: 2 },
        ],
      },
      {
        id: 6,
        title: "Bill of Lading Details",
        growValue: 6,
        isHeader: false,
        imgUrl: "https://res.cloudinary.com/ddfycftwg/image/upload/v1640251778/images/website/api-integration/delivery-box_1_1_niaysj.svg",
        data: [
          { label: "Total Shipment Value (USD)", valuePrefix: "USD ", value: "total_shipment_value_usd" },
          { label: "Total Invoice Value (USD)", valuePrefix: "USD ", value: "derived_total_invoice_value_usd", tooltip: true, tooltipField: "total_invoice_value_rubles", tooltipPrefix: "RUB " },
          { label: "Total Customs Value (USD)", valuePrefix: "USD ", value: "derived_total_customs_value_usd", tooltip: true, tooltipField: "total_customs_value_rubles", tooltipPrefix: "RUB " },
          { label: "Total Gross Weight (kg)", value: "derived_total_gross_weight_kg", valueSuffix: " kg" },
          { label: "Total Net Weight (kg)", value: "derived_total_net_weight_kg", valueSuffix: " kg" },
        ],
      },
    ],
    defaultKey: { country_small: "turkey", countryCaps: "TURKEY" },
    apiUrlDownload: getApiUrl("renderToPdfTurkeyImports"),
  },
  "turkey exports": {
    apiUrl: getApiUrl("intelSearchTurkeyExportShipmentByID"),
    viewShipmentObject: [
      {
        id: 1,
        title: "",
        growValue: 12,
        isHeader: true,
        imgUrl: "",
        data: [
          { label: "Date of Declaration", value: "date_of_declaration", dateFormat: true, monthFormat: false },
          { label: "Date of Arrival", value: "date_of_arrival", dateFormat: true, monthFormat: true },
          { label: "Declaration Number", value: "derived_declaration_number" },
          { label: "Item Number", value: "itemCount" },
          { label: "Item Count", value: "total_item_count", isViewAll: "is_view_all", shipmentRedirect: true, requestId: "derived_declaration_number", requestNum: "total_item_count" },
          { label: "HS Code", value: "hs_code" },
          { label: "Mode of Transportation", value: "derived_mode_of_transportation_english" },
          { label: "Incoterm", value: "derived_incoterm_code_description_combined" },
        ],
      },
      {
        id: 2,
        title: "Shipment Origin Details",
        isConnectedColumn: true,
        isCompactHeader: true,
        growValue: 6,
        isHeader: false,
        imgUrl: "",
        data: [
          { label: "Country of Export", value: "derived_country_of_export", isCapitalise: false, tooltip: true, tooltipField: "country_of_origin_russian", countryCodeField: "derived_country_of_export_code", countryFlag: true },
          { label: "Producer Name", value: "derived_producer_name_english" },
          { label: "Producer Name (Russian)", value: "producer_name_russian" },
          { label: "Shipper Standardized Name", type: "redirect", companyIdKey: "derived_shipper_master_company_id", companyKey: "", derivedCompanyKey: "derived_shipper_master_name", tradeDirection: "E" },
          { label: "Shipper Name", value: "derived_shipper_name_english" },
          { label: "Shipper Name (Russian)", value: "shipper_name_russian" },
          { label: "Shipper Code", value: "shipper_code" },
          { label: "Shipper Type", value: "derived_is_exporter" },
          { label: "Shipper Address", value: "derived_shipper_address_english", isReadMore: true, readMoreLength: 45 },
          { label: "Shipper Address (Russian)", value: "shipper_address_russian", isReadMore: true, readMoreLength: 45 },
          { label: "Shipper City", value: "derived_shipper_city" },
          { label: "Shipper State", value: "derived_shipper_state" },
          { label: "Shipper Jurisdiction Country ", value: "derived_shipper_jurisdiction_country", countryFlag: true, countryCodeField: "derived_shipper_jurisdiction_country_code" },
          { label: "Shipper Pincode", value: "derived_shipper_pin_code" },
        ],
      },
      {
        id: 3,
        title: "Shipment Destination Details",
        growValue: 6,
        isHeader: false,
        isCompactHeader: true,
        imgUrl: "",
        data: [
          { label: "Country of Import", value: "derived_country_of_import", countryCodeField: "derived_country_of_import_code", countryFlag: true },
          // { label: 'Place of Delivery', value: 'derived_place_of_delivery_english', tooltip: true, tooltipField: 'place_of_delivery_russian' },
          // { label: "Country of Destination", value: "derived_country_of_destination_english" },
          { label: "Consignee Standardized Name", value: "derived_consignee_master_name", type: "redirect", companyIdKey: "derived_consignee_master_company_id", companyKey: "", derivedCompanyKey: "derived_consignee_master_name", tradeDirection: "I" },
          { label: "Consignee Name", value: "derived_consignee_name_english", isCapitalise: true },
          { label: "Consignee Name (Russian)", value: "consignee_name_russian", isCapitalise: true },
          { label: "Consignee Jurisdiction Country ", value: "derived_consignee_jurisdiction_country", countryFlag: true, countryCodeField: "derived_consignee_jurisdiction_country_code" },
          { label: "Consignee Code", value: "consignee_code" },
          { label: "Consignee Type", value: "derived_is_importer" },
          { label: "Consignee Address", value: "derived_consignee_address_english", isReadMore: true, readMoreLength: 45 },
          { label: "Consignee Address (Russian)", value: "consignee_address_russian", isReadMore: true, readMoreLength: 45 },
        ],
      },
      {
        id: 4,
        title: "Carrier Details",
        growValue: 6,
        isHeader: false,
        imgUrl: "https://res.cloudinary.com/ddfycftwg/image/upload/v1640251816/images/website/api-integration/ship-gray_1_jqiqaq.svg",
        data: [{ label: "Type of Vehicle", value: "derived_type_of_vehicle_english", tooltip: true, tooltipField: "type_of_vehicle_russian" }],
      },
      {
        id: 5,
        title: "Cargo Details",
        growValue: 6,
        isHeader: false,
        hideCargo: "bol",
        imgUrl: "https://res.cloudinary.com/ddfycftwg/image/upload/v1640251778/images/website/api-integration/delivery-box_1_1_niaysj.svg",
        data: [
          { label: "Product Description", value: "derived_product_description_english", isReadMore: true, readMoreLength: 45 },
          { label: "Product Description (Russian)", value: "product_description_russian", isReadMore: true, readMoreLength: 45 },
          { label: "Product Trademark", value: "derived_product_brand_trademark_english", tooltip: true, tooltipField: "product_brand_trademark_russian" },
          { label: "Quantity", value: "quantity", unitField: "derived_quantity_unit_english", dynamicUnit: true, unitField2: "", dynamicUnit2: false, tooltip: true, tooltipField: "quantity", tooltipField2: "quantity_unit_russian" },
          { label: "Gross Weight (kg)", value: "gross_weight_kg", valueSuffix: " kg", isCommaFormat: true, infoText: "Gross weight is the weight of the shipment measured after packaging" },
          { label: "Net Weight (kg)", value: "net_weight_kg", valueSuffix: " kg", isCommaFormat: true, infoText: "Net weight is the weight of the shipment measured after packaging" },
          { label: "Shipment Value Per Unit (USD)", value: "derived_shipment_value_usd_per_unit", valuePrefix: "USD " },
          { label: "Shipment Value (USD)", value: "shipment_value_usd", valuePrefix: "USD " },
          { label: "Per Unit Value", value: "derived_shipment_value_usd_per_quantity_unit", valuePrefix: "USD ", isCommaFormat: true },
          { label: "Invoice Value (USD)", value: "derived_invoice_value_usd", valuePrefix: "USD ", tooltip: true, tooltipField: "invoice_value_rubles", tooltipPrefix: "RUB ", isCommaFormat: true, fixedValueUpto: 2 },
          { label: "Customs Value (USD)", value: "derived_customs_value_usd", valuePrefix: "USD ", tooltip: true, tooltipField: "customs_value_rubles", tooltipPrefix: "RUB ", isCommaFormat: true, fixedValueUpto: 2 },
        ],
      },
      {
        id: 6,
        title: "Bill of Lading Details",
        growValue: 6,
        isHeader: false,
        imgUrl: "https://res.cloudinary.com/ddfycftwg/image/upload/v1640251778/images/website/api-integration/delivery-box_1_1_niaysj.svg",
        data: [
          { label: "Total Shipment Value (USD)", valuePrefix: "USD ", value: "total_shipment_value_usd" },
          { label: "Total Invoice Value (USD)", valuePrefix: "USD ", value: "derived_total_invoice_value_usd", tooltip: true, tooltipField: "total_invoice_value_rubles", tooltipPrefix: "RUB " },
          { label: "Total Customs Value (USD)", valuePrefix: "USD ", value: "derived_total_customs_value_usd", tooltip: true, tooltipField: "total_customs_value_rubles", tooltipPrefix: "RUB " },
          { label: "Total Gross Weight (kg)", value: "derived_total_gross_weight_kg", valueSuffix: " kg" },
          { label: "Total Net Weight (kg)", value: "derived_total_net_weight_kg", valueSuffix: " kg" },
        ],
      },
    ],
    defaultKey: { country_small: "turkey", countryCaps: "TURKEY" },
    apiUrlDownload: getApiUrl("renderToPdfTurkeyExports"),
  },
};
